$(document).ready(function(){

  $().fancybox({
    selector: '[data-fancybox]',
    toolbar: true,
    buttons: ['close']
  });

});
